export enum RefreshAuthResultEnum {
  NO_STORED,
  EXPIRED,
  SUCCESS,
  ERROR,
  PLATFORM_NOT_SUPPORTED,
}
